// import '@ant-design/v5-patch-for-react-19';
import { setupGlobalErrorHandling, retryFailedLogs } from './services/errorLogger';
import { cacheManager } from './utils/cacheManager';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/styles/responsive.css';
import './assets/styles/mobile.css';
import './forced-colors.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 初始化错误监控
setupGlobalErrorHandling();
retryFailedLogs(); // 启动时重试失败日志

// 注册Service Worker和缓存管理
if (process.env.NODE_ENV === 'production') {
  cacheManager.registerServiceWorker();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
